// „Разнасяне с недостиг" — потвърждение САМО когато след замените още има
// продукти под нула (без недостиг разнасянето минава направо). Общият
// потвърждаващ диалог (components/confirm): кой отчет, кои продукти и колко
// не достигат, какво става с наличността и откъде се връща. Esc отказва,
// Enter потвърждава (фокусът е на основния бутон, както досега).
import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ConfirmDialog } from "../../components/confirm/ConfirmDialog";

export type ShortageItem = { key: string; name: string; missing: string };

type Props = {
  open: boolean;
  reportNumber: number | string;
  items: ShortageItem[];
  saving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ReportPostingShortageConfirmModal = ({
  open,
  reportNumber,
  items,
  saving,
  onCancel,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      intent="warning"
      icon={<ExclamationCircleOutlined />}
      title={t("inventoryPage.cfmShortageTitle", { count: items.length, number: reportNumber })}
      explanation={t("inventoryPage.cfmShortageText")}
      preview={{
        caption: t("inventoryPage.cfmShortageCaption"),
        items: items.map((item) => ({
          key: item.key,
          label: item.name,
          value: `−${item.missing}`,
          tone: "danger",
        })),
        limit: 8,
      }}
      note={{
        kind: "undo",
        text: t("inventoryPage.cfmShortageUndo", { report: t("inventoryPage.navPostedReports") }),
      }}
      confirmLabel={t("inventoryPage.cfmShortageConfirm")}
      busy={saving}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ReportPostingShortageConfirmModal;
